import React from 'react'
import {conditionSummary, getInputTypeLabel, IQuestionModel} from './QuestionModel'
import DataTable, {TableAction, TableColumn} from '../../../../shared/components/DataTable'

type Props = {
  data: IQuestionModel[]
  currentPage: number
  totalPages: number
  onPageChange: (page: number) => void
  onEdit: (question: IQuestionModel) => void
  onDelete: (question: IQuestionModel) => void
  loading?: boolean
}

export const QuestionTable: React.FC<Props> = ({
  data,
  currentPage,
  totalPages,
  onPageChange,
  onEdit,
  onDelete,
  loading = false,
}) => {
  const columns: TableColumn<IQuestionModel>[] = [
    {
      key: 'label',
      label: 'Soru',
      render: (_, question) => (
        <div className='d-flex flex-column'>
          <span className='fw-semibold'>{question.label}</span>
          {question.options?.length > 0 && (
            <span className='text-muted fs-7'>{question.options.join(' · ')}</span>
          )}
        </div>
      ),
    },
    {
      key: 'inputType',
      label: 'Cevap Tipi',
      width: '150px',
      render: (inputType: string) => (
        <span className='badge badge-light-info'>{getInputTypeLabel(inputType)}</span>
      ),
    },
    {
      key: 'required',
      label: 'Zorunlu',
      width: '100px',
      render: (required: boolean) =>
        required ? (
          <span className='badge badge-light-warning'>Zorunlu</span>
        ) : (
          <span className='text-muted fs-7'>İsteğe bağlı</span>
        ),
    },
    {
      key: 'conditionOperator',
      label: 'Koşul / Otomatik Mail',
      width: '260px',
      render: (_, question) =>
        !question.conditionOperator ? (
          <span className='text-muted fs-7'>-</span>
        ) : (
          <div className='d-flex flex-column'>
            <span className='fs-7'>{conditionSummary(question)}</span>
            {question.failMailTemplateName ? (
              <span className='text-muted fs-8'>
                <i className='bi bi-envelope me-1'></i>
                {question.failMailTemplateName}
              </span>
            ) : (
              <span className='text-muted fs-8'>Mail gönderilmiyor</span>
            )}
          </div>
        ),
    },
  ]

  const actions: TableAction<IQuestionModel>[] = [
    {
      label: 'Düzenle',
      icon: 'bi bi-pencil',
      className: 'btn-light-primary me-2',
      onClick: onEdit,
    },
    {
      label: 'Sil',
      icon: 'bi bi-trash',
      className: 'btn-light-danger',
      onClick: onDelete,
    },
  ]

  return (
    <DataTable
      data={data}
      columns={columns}
      actions={actions}
      showPagination={true}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={onPageChange}
      loading={loading}
      emptyMessage='Henüz soru bulunamadı'
    />
  )
}
